/**
 * Application main entry point.
 */
import React from "react";
import ReactDOM from "react-dom";

import { initializeSentry } from "@utils/sentry";

import App from "./App";

// Set up sentry error handling so we can capture any errors as early as possible.
initializeSentry();

// Set the api domain so we know where to send API requests.
window.serverContext = {};

// Render our application.
function main(err) {
  if (err && err instanceof Error) {
    console.error("[TODO][main]:", err);
  }
  ReactDOM.render(React.createElement(App), document.getElementById("root"));
}

if (window.Promise && window.fetch && window.URL) {
  main();
} else {
  import("./polyfills.js").then(main, main);
}
